import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { path_url } from "../../Config/config";
import DataTable from "react-data-table-component";
import jsPDF from "jspdf";
import { Dropdown, DropdownButton } from "react-bootstrap";
import OutsideClickHandler from "react-outside-click-handler";
import { filterByStatus } from "../../Utils/StatusConfig";
function VendorDashboardTable({ filterStatus }) {
  const [vendorList, setVendorList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedColumns, setSelectedColumns] = useState({});
  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem("accessToken");
  const adminId = localStorage.getItem("adminId");

  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        const { year, month } = location.state || {};

        const res = await axios.get(`${path_url}/vendor/dashboard/${adminId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          params: {
            year: year,
            month: month,
          },
        });
        setVendorList(res.data.body.vendorList || []);
        setFilteredData(res.data.body.vendorList || []);
      } catch (error) {
        console.log("Error fetching customer data:", error);
      }
    };
    fetchCustomerData();
  }, [adminId, token, location.state]);

  useEffect(() => {
    let baseData = vendorList;
    if (filterStatus) {
      baseData = filterByStatus(vendorList, filterStatus, "vendor");

      // Debugging: Log status values to verify alignment with dashboard
      baseData.forEach((item) => console.log("Vendor Status:", item.status));
    }

    setFilteredData(
      baseData.filter((item) =>
        Object.values(item).some((value) =>
          String(value).toLowerCase().includes(searchText.toLowerCase()),
        ),
      ),
    );
  }, [searchText, vendorList, filterStatus]);

  const columns = [
    {
      name: <strong>Name</strong>,
      selector: (row) => `${row.firstname} ${row.lastname}`,
      sortable: true,
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => navigate(`/vendor-details/${row.id}`)}
        >
          {row.firstname} {row.lastname}
        </span>
      ),
    },
    {
      name: <strong>Company</strong>,
      selector: (row) => row.companyname,
      sortable: true,
    },
    {
      name: <strong>Status</strong>,
      selector: (row) => row.status,
      sortable: true,
    },
    { name: <strong>Mobile</strong>, selector: (row) => row.mobile },
    { name: <strong>Email</strong>, selector: (row) => row.email },
    { name: <strong>Notes</strong>, selector: (row) => row.notes },
    { name: <strong>Pincode</strong>, selector: (row) => row.pincode },
    { name: <strong>Product</strong>, selector: (row) => row.product },
    { name: <strong>Address1</strong>, selector: (row) => row.add1 },
    { name: <strong>Address2</strong>, selector: (row) => row.add2 },
    { name: <strong>City</strong>, selector: (row) => row.city },
    { name: <strong>State</strong>, selector: (row) => row.state },
    { name: <strong>Country</strong>, selector: (row) => row.country },
  ];

  useEffect(() => {
    const initialColumns = columns.reduce(
      (acc, col) => ({ ...acc, [col.name]: true }),
      {},
    );
    setSelectedColumns(initialColumns);
  }, []);

  const visibleColumns = columns.filter((col) => selectedColumns[col.name]);

  const printTable = () => {
    const printWindow = window.open("", "", "width=800,height=600");
    let tableContent = `<table border="1" style="width:100%; border-collapse: collapse;">
      <tr>${visibleColumns.map((col) => `<th>${col.name}</th>`).join("")}</tr>
      ${filteredData
        .map(
          (row) =>
            `<tr>${visibleColumns.map((col) => `<td>${col.selector(row)}</td>`).join("")}</tr>`,
        )
        .join("")}
    </table>`;
    printWindow.document.write(tableContent);
    printWindow.document.close();
    printWindow.print();
  };

  const copyToClipboard = () => {
    const textToCopy = filteredData
      .map((row) => visibleColumns.map((col) => col.selector(row)).join(", "))
      .join("\n");
    navigator.clipboard.writeText(textToCopy);
    alert("Table data copied to clipboard!");
  };
  // Export CSV
  const exportCSV = () => {
    const csvContent =
      "data:text/csv;charset=utf-8," +
      [
        columns.map((col) => col.name).join(","), // Headers
        ...filteredData.map((row) =>
          columns.map((col) => col.selector(row)).join(","),
        ),
      ].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "customers.csv");
    document.body.appendChild(link);
    link.click();
  };

  // Export PDF
  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Customer Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [columns.map((col) => col.name)],
      body: filteredData.map((row) => columns.map((col) => col.selector(row))),
    });
    doc.save("customers.pdf");
  };

  const [visibile, setVisible] = useState(false);
  const handleDrop = () => {
    setVisible(!visibile);
  };
  const [Id, setId] = useState(true);
  const [Subject, setSubject] = useState(true);
  const [Status, setStatus] = useState(true);
  const [Duedate, setDuedate] = useState(true);
  const [Assigned, setAssigned] = useState(true);
  const [Priority, setPriority] = useState(true);
  const [Created, setCreated] = useState(true);

  const handleID = () => {
    setId(!Id);
    setVisible(true);
  };
  const handleSubject = () => {
    setSubject(!Subject);
    setVisible(true);
  };
  const handleStatus = () => {
    setStatus(!Status);
    setVisible(true);
  };
  const handlePriority = () => {
    setPriority(!Priority);
    setVisible(true);
  };
  const handleAssigned = () => {
    setAssigned(!Assigned);
    setVisible(true);
  };
  const handleCreated = () => {
    setCreated(!Created);
    setVisible(true);
  };
  const handleDuedate = () => {
    setDuedate(!Duedate);
    setVisible(true);
  };

  return (
    <div className="container mt-3">
      <section className="content">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h3 className="card-title">Vendor Table</h3>
          </div>
          <div className="card-body">
            <div className="d-flex justify-content-between mb-2">
              <div
                className="bg-secondary mx-2 rounded Action d-flex"
                style={{
                  marginLeft: "5px",
                  padding: "7px",
                  height: "50px",
                  marginTop: "8px",
                }}
              >
                {/* <button className="btn btn-secondary btn-sm mx-1" onClick={copyToClipboard}>Copy</button>
                <button className="btn btn-secondary btn-sm mx-1" onClick={printTable}>Print Table</button>
                <button className="btn btn-secondary btn-sm mx-1" onClick={exportCSV}>CSV</button>
                <button className="btn btn-secondary btn-sm mx-1" onClick={exportPDF}>PDF</button> */}
                <label
                  htmlFor=""
                  className="px-2 py-1 m-0 item"
                  onClick={copyToClipboard}
                >
                  Copy
                </label>
                <label
                  htmlFor=""
                  className="px-2 py-1 m-0 item"
                  onClick={exportCSV}
                >
                  CSV
                </label>
                <label
                  htmlFor=""
                  className="px-2 py-1 m-0 item"
                  onClick={exportPDF}
                >
                  PDF
                </label>
                <label
                  htmlFor=""
                  className="px-2 py-1 m-0 item"
                  onClick={printTable}
                >
                  Print
                </label>
                <OutsideClickHandler
                  onOutsideClick={() => {
                    setVisible(false);
                  }}
                >
                  <div className="dropdown">
                    <label
                      htmlFor=""
                      className="px-2 py-1 m-0 item btn  dropdown-toggle"
                      onClick={handleDrop}
                      data-toggle="dropdown"
                      style={{
                        color: "#fff",
                      }}
                    >
                      Column Visibility
                    </label>

                    {/* Custom dropdown for column visibility */}
                    <div
                      className={`dropdown-menu ${
                        visibile ? "show" : ""
                      } dropdown-menu-right`}
                    >
                      {/* Add your dropdown content here */}
                      <div
                        className="menuItem"
                        onClick={handleID}
                        style={{
                          width: "200px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          marginLeft: "5px",
                          marginRight: "5px",
                          borderRadius: "1px",
                          backgroundColor: Id ? "#007bff" : "",
                          color: Id ? "white" : "",
                        }}
                      >
                        ID
                      </div>
                      <div
                        className="menuItem"
                        onClick={handleSubject}
                        style={{
                          width: "200px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          marginLeft: "5px",
                          marginRight: "5px",
                          borderRadius: "1px",
                          backgroundColor: Subject ? "#007bff" : "",
                          color: Subject ? "white" : "",
                        }}
                      >
                        Subject
                      </div>
                      <div
                        className="menuItem"
                        onClick={handleStatus}
                        style={{
                          width: "200px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          marginLeft: "5px",
                          marginRight: "5px",
                          borderRadius: "1px",
                          backgroundColor: Status ? "#007bff" : "",
                          color: Status ? "white" : "",
                        }}
                      >
                        Status
                      </div>
                      <div
                        className="menuItem"
                        onClick={handleDuedate}
                        style={{
                          width: "200px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          marginLeft: "5px",
                          marginRight: "5px",
                          borderRadius: "1px",
                          backgroundColor: Duedate ? "#007bff" : "",
                          color: Duedate ? "white" : "",
                        }}
                      >
                        Due Date
                      </div>
                      <div
                        className="menuItem"
                        onClick={handlePriority}
                        style={{
                          width: "200px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          marginLeft: "5px",
                          marginRight: "5px",
                          borderRadius: "1px",
                          backgroundColor: Priority ? "#007bff" : "",
                          color: Priority ? "white" : "",
                        }}
                      >
                        Priority
                      </div>
                      <div
                        className="menuItem"
                        onClick={handleAssigned}
                        style={{
                          width: "200px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          marginLeft: "5px",
                          marginRight: "5px",
                          borderRadius: "1px",
                          backgroundColor: Assigned ? "#007bff" : "",
                          color: Assigned ? "white" : "",
                        }}
                      >
                        Assigned
                      </div>
                      <div
                        className="menuItem"
                        onClick={handleCreated}
                        style={{
                          width: "200px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          marginLeft: "5px",
                          marginRight: "5px",
                          borderRadius: "1px",
                          backgroundColor: Created ? "#007bff" : "",
                          color: Created ? "white" : "",
                        }}
                      >
                        Created
                      </div>
                      {/* Add more dropdown items as needed */}
                    </div>
                  </div>
                </OutsideClickHandler>
              </div>
              {/* <DropdownButton id="dropdown-basic-button" title="Column Visibility">
                {columns.map(col => (
                  <Dropdown.Item key={col.name}>
                    <input
                      type="checkbox"
                      checked={selectedColumns[col.name]}
                      onChange={() =>
                        setSelectedColumns(prev => ({ ...prev, [col.name]: !prev[col.name] }))
                      }
                    /> {col.name}
                  </Dropdown.Item>
                ))}
              </DropdownButton> */}

              {/* <input type="text" className="form-control w-25" placeholder="Search..." value={searchText} onChange={(e) => setSearchText(e.target.value)} /> */}
              <div className="Next2">
                <label htmlFor="" className="p-0 mx-1 my-0">
                  Search :
                </label>
                <input
                  type="text"
                  className="Next3"
                  onChange={(e) => setSearchText(e.target.value)} // Add onChange event to handle search
                  value={searchText}
                  style={{
                    "border-radius": "unset",
                    border: "1px solid ",
                    borderRadius: "0",
                    marginTop: "7px",
                  }}
                />
              </div>
            </div>
            <DataTable
              columns={visibleColumns}
              data={filteredData}
              pagination
              highlightOnHover
              striped
              responsive
              customStyles={{
                headCells: {
                  style: {
                    fontWeight: "bold",
                    fontSize: "16px",
                  },
                },
              }}
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default VendorDashboardTable;
